import React from 'react';
import PropTypes from 'prop-types';
import { isAbleToSendOfferEmail } from '../helpers/opportunitiesListHelper';
import OrderProp from '../../../shop/propTypes/orderProp';
import translate from '../../../../commonComponents/translate';

function Actions({ t, opportunity, loggedUserId }) {
  const { status, _id, owner } = opportunity;
  const isUserTheSponsor = owner?.sponsoredBy === loggedUserId;

  return (
    <div>
      <span className="dropdown">
        <a
          href="#"
          className="btn m-btn m-btn--hover-brand m-btn--icon m-btn--icon-only m-btn--pill"
          data-toggle="dropdown"
          aria-expanded="false"
        >
          <i className="la la-ellipsis-h" />
        </a>
        <div
          className="dropdown-menu dropdown-menu-right"
          x-placement="bottom-end"
        >
          <a
            className="dropdown-item"
            href={`/shop/opportunity/${opportunity._id}`}
          >
            <i className="la la-search" />
            {t('opportunities.detail')}
          </a>
          {isAbleToSendOfferEmail(status) && isUserTheSponsor && (
            <a
              className="dropdown-item"
              href={`/shop/opportunities/${opportunity._id}/edit`}
            >
              <i className="la la-edit" />
              {t('opportunities.edit')}
            </a>
          )}
          {isAbleToSendOfferEmail(status) && (
            <a
              className="dropdown-item resend-offer"
              href="#"
              data-opportunity-id={_id}
            >
              <i className="la la-envelope" />
              {t('send.offer.email')}
            </a>
          )}
        </div>
      </span>
    </div>
  );
}

Actions.propTypes = {
  t: PropTypes.func.isRequired,
  opportunity: PropTypes.shape(OrderProp.propType).isRequired,
  loggedUserId: PropTypes.string.isRequired,
};

Actions.defaultProps = {};

export default translate(Actions);
